import config from 'constants/apiConfig';
import axios from 'axios';

export type ExportPlannedResourceAsFormParams = {
  walaId: string;
  plannedResourceId: string;
  format?: 'pdf' | 'docx';
};

export const ICS_204A_FORM_NAME = 'ICS_204A_CG';

export type Ics204aExportResult = {
  pdfBase64?: string;
  docxBase64?: string;
};

export async function postExportPlannedResourceAsForm(
  periodNumber: number,
  { walaId, plannedResourceId, format = 'pdf' }: ExportPlannedResourceAsFormParams
): Promise<{
  formName: string;
  format: 'pdf' | 'docx';
  data: string | Ics204aExportResult;
}> {
  const response = await axios.post<string | Ics204aExportResult>(
    `${config.apiGateway.ics_planned_resource}/${plannedResourceId}/export`,
    {
      walaId,
      periodNumber,
      skipWorkspaceUpload: true,
      format,
    }
  );
  return { formName: ICS_204A_FORM_NAME, format, data: response.data };
}
